var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('h1',{staticClass:"page-title"},[_vm._v("Database operation")]),_c('div',{staticClass:"commands"},[_c('v-btn',{on:{"click":_vm.seedUsers}},[_vm._v("Seed users")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }